module.exports = __webpack_public_path__ + "img/d200904-3.95bf34ee.jpg";